export enum CompareModeType {
  Preview = 'Preview',
  Merge = 'Merge',
}
